export function ActiveIcon() {
    return (
      
        <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <path fill="#16F298" d="M16 22a6 6 0 100-12 6 6 0 000 12z"></path>
      <path
        fill="url(#paint0_radial_23_2396)"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
      ></path>
      <defs>
        <radialGradient
          id="paint0_radial_23_2396"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(0 16 -16 0 16 16)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#16F298" stopOpacity="0.8"></stop>
          <stop offset="0.276" stopColor="#16F298" stopOpacity="0.358"></stop>
          <stop offset="0.807" stopColor="#16F298" stopOpacity="0"></stop>
        </radialGradient>
      </defs>
    </svg>
      
    );
  }